import React from 'react';
import '../../stylings/LineSeperator.css';

export default function LineSeperator({ title }) {
  return (
    <div className="line-sep-wrapper">
      {title && <h2 className="line-sep-title">{title}</h2>}
      <div className="line-sep-bar">
        <span className="line-sep-left"></span>
        <span className="line-sep-diamond"></span>
        <span className="line-sep-right"></span>
      </div>
    </div>
  );
}
